import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import * as SharedAnalysisResultsSelectors from '../selectors/shared-analysis-results.selectors';
import * as SharedAnalysisResultsStore from '../reducers/shared-analysis-results.reducer';
import { ErrorStore, SharedAnalysisResults } from '@sleipai/sleip-models';

@Injectable()
export class SharedAnalysisResultsStoreFacade {
  constructor(
    private readonly store: Store<SharedAnalysisResultsStore.State>
  ) {}

  currentSharedAnalysisEntityLoaded$: Observable<boolean> = this.store.pipe(
    select(
      SharedAnalysisResultsSelectors.selectSingleSharedAnalysisResultsByIdAndKey
    ),
    map(
      (sharedAnalysisResults: SharedAnalysisResults[] | null) =>
        sharedAnalysisResults !== null && sharedAnalysisResults.length !== 0
    )
  );

  getCurrentSharedAnalysisResultsList$: Observable<
    SharedAnalysisResults[] | null
  > = this.store.pipe(
    select(
      SharedAnalysisResultsSelectors.selectSingleSharedAnalysisResultsByIdAndKey
    )
  );

  getSharedAnalysisResultsError$: Observable<ErrorStore | null> =
    this.store.pipe(
      select(SharedAnalysisResultsSelectors.selectSharedAnalysisResultsError)
    );
}
